import { Icon } from '~/components/atomic';
import * as S from './ErrorBoundaryLayout.styled';

interface ErrorBoundaryProps {
  onClick?: () => void;
}

export default function ErrorBoundaryLayout({ onClick }: ErrorBoundaryProps) {
  const handleReload = () => {
    window.location.reload();
  };
  return (
    <S.Container>
      <S.InfoBox>
        <p>
          Data communication <br /> has been temporarily lost.
        </p>
      </S.InfoBox>
      <S.ButtonBox>
        <S.Button onClick={onClick ? onClick : handleReload}>
          <Icon size={20} iconName='Reload' />
          <span>Reload</span>
        </S.Button>
      </S.ButtonBox>
    </S.Container>
  );
}
